import { getEsgColorIndex } from "common/esg-helpers";
export const addEsgColorIndexVisitor = (groupByField) => (args) => {
    if (!groupByField || groupByField === "") {
        return;
    }
    const esgGroup = args.visitable.measures?.[groupByField];
    if (!esgGroup) {
        return;
    }
    if (!args.visitable.additionalData) {
        args.visitable.additionalData = {};
    }
    args.visitable.additionalData.colorIndex = getEsgColorIndex(esgGroup);
};
